import styled from "styled-components";
import { colorV2, media, typographyV2 } from "../../../../constants/styles";
import { ProjectInfo } from "../../../../constants/projects";

interface Props {
  info: ProjectInfo;
}
const ProjectDetailInfo: React.FC<Props> = ({ info }) => {

  return (
    <Container backgroundColor={info.color}>
      <ContentContainer>
        <InfoBox>
          <p>Client</p>
          <p>{info.client}</p>
        </InfoBox>
        <InfoBox>
          <p>Tech</p>
          <p>{info.skills.join(', ')}</p>
        </InfoBox>
        <InfoBox>
          <p>Service Consulting</p>
          <p>{info.consultings.join(', ')}</p>
        </InfoBox>
        <InfoBox>
          <p>Project Period</p>
          <p>{info.period}</p>
        </InfoBox>
      </ContentContainer>

    </Container>
  )
};

export default ProjectDetailInfo

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap:42px;
  max-width: 1200px;
  margin: 0 auto;
  ${media.MOBILE} {
    grid-template-columns: repeat(1, 1fr);
    gap: 32px;
  }
`;

const Container = styled.div<{ backgroundColor: string }>`
  background-color:${({ backgroundColor }) => backgroundColor};
  padding: 80px 48px;
  width: 100%;

  ${media.TABLET} {
    padding: 60px 48px;
  }
  ${media.MOBILE} {
    padding: 40px 24px;
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;
  word-break: keep-all;

  color: ${colorV2.GRAY_10};
  p:first-child {
    flex:1;
    opacity: 0.8;
    ${typographyV2.BODY_5_M};
    font-weight: 500;
  }

  p:nth-child(2) {
    flex:1;
    ${typographyV2.HEADING_7_B}; 
  }

  ${media.TABLET} {
    flex-direction: column;
    gap: 8px;
  }
  ${media.MOBILE} {}
`;